import { memo, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getRouteSeo, usePageSeo } from "../lib/seo";

/**
 * Applies per-route title, meta description, canonical, and robots for public SPA pages.
 * Blog post pages set their own SEO in BlogPost.jsx.
 */
function RouteSeo() {
  const { pathname } = useLocation();
  const config = useMemo(() => getRouteSeo(pathname), [pathname]);
  usePageSeo({
    title: config?.title ?? "",
    description: config?.description ?? "",
    path: config?.path ?? pathname,
    noindex: config?.noindex,
    jsonLd: config?.jsonLd,
    enabled: Boolean(config),
  });
  return null;
}

export default memo(RouteSeo);
